const CONSTANTS = module.exports = {};
CONSTANTS.SUPPLIER_GATEWAYS = {
    TRAVELGATE: 'travelgate'
};

CONSTANTS.RECHECK_BUCKETS = {
    DEFAULT: 'default',
    LAZY: 'lazy',
};

CONSTANTS.TRAVELGATE_BOOKABLE_SUPPLIERS = {
    ABREU: 'abreu',
    ASK2TRAVEL: 'ask2travel',
    COSMOBEDS: 'cosmobeds',
    DARINA: 'darina',
    DIDA: 'dida',
    DOTW: 'dotw',
    G2TRAVEL: 'g2travel',
    HOTELDO: 'hoteldo',
    HOTELTRADER: 'hoteltrader',
    HOTELSENSE: 'hotelsense',
    IMPERA: 'impera',
    IOL: 'iol',
    LETSFLY: 'letsfly',
    MIKI: 'miki',
    PRICETRAVEL: 'pricetravel',
    RAKUTEN: 'rakuten',
    RTS: 'rts',
    ROOMERANG: 'roomerang',
    THREEFULLSTEPS: "threefullsteps",
    SMYROOMS: 'smyrooms',
    TRAVCO: 'travco',
    TRAVCODUBAI: 'travcodubai',
    VOYAGETOURS: 'voyagetours',
    WORLD2MEET: 'world2meet',
    YALAGO: 'yalago',
};

CONSTANTS.SUPPLIERS = CONSTANTS.RESERVATION_SOURCES = {
    NA: 'not_exists',
    AGODA_OTA: 'ota-agoda.com', // maybe hotel website or conference website etc..

    ARBITRIP: 'sup-arbitrip',

    ARN: 'sup-arn', // Obsolete
    BOOKING: 'sup-booking',
    BOOKING_OTA: 'ota-booking.com', // direct booking on site, booked outside the system
    // EAN : 'sup-ean', // for ean and not expediaSite. Currently, not supported
    EXPEDIA: 'sup-expedia', // for expediaSite and not ean,
    EXPEDIA_OTA: 'ota-expedia.com', // direct booking on site, booked outside the system

    HOTELBEDS: 'sup-hotelbeds',
    HOTELS_OTA: 'ota-hotels.com',    // direct booking on site, booked outside the system,
    HYPERGUEST: 'sup-hyperguest',
    GENERAL: 'general', // maybe hotel website or conference website etc..
    DRIVADO: 'drivado', // drivado transportation service platform
    GOGLOBAL: 'sup-goglobal',
    PREMIERINN: 'sup-premierinn',
    PTC: 'sup-ptc',
    RESTEL: 'sup-restel',
    SUNHOTELS: 'sup-sunhotels',
    CTRIP: 'sup-ctrip',
    TBOHOLIDAYS: 'sup-tboholidays',
    TRAVELPORT: 'sup-travelport',
    TRAVOLUTIONARY: 'sup-travolutionary',
    YAYA: 'sup-yaya',

    // Travelgate
    ABREU: 'tgx-abreu',
    ASK2TRAVEL: 'tgx-ask2travel',
    COSMOBEDS: 'tgx-cosmobeds',
    DARINA: 'tgx-darina',
    DIDA: 'tgx-dida',
    DOTW: 'tgx-dotw',
    G2TRAVEL: 'tgx-g2travel',
    HOTELTRADER: 'tgx-hoteltrader',
    HOTELSENSE: 'tgx-hotelsense',
    HOTELDO: 'tgx-hoteldo',
    IOL: 'tgx-iol',
    IMPERA: 'tgx-impera',
    LETSFLY: 'tgx-letsfly',
    MIKI: 'tgx-miki',
    PRICETRAVEL: 'tgx-pricetravel',
    RAKUTEN: 'tgx-rakuten',
    ROOMERANG: 'tgx-roomerang',
    RTS: 'tgx-rts',
    SMYROOMS: 'tgx-smyrooms',
    THREEFULLSTEPS: 'tgx-threefullsteps',
    TRAVCO: 'tgx-travco',
    TRAVCODUBAI: 'tgx-travcodubai',
    VOYAGETOURS: 'tgx-voyagetours',
    WORLD2MEET: 'tgx-world2meet',
    YALAGO: 'tgx-yalago',
};

////////////////////////////////////////////////////////////////////////////////

CONSTANTS.TRAVOLUTIONARY_SUB_SUPPLIERS = {
    // Add here when more subsuppliers are added
    BONOTEL: 'bonotel',
    // DIDA: 'dida',
    GETAROOM: 'getaroom',
    // GOGLOBAL: 'go global',
    HOTELSPRO: 'hotelspro',
    // HYPERGUEST: 'hyperguest',
    // MIKITOURS: 'miki',
    NUITEE: 'nuitee',
    TBO: 'tbo',
    TOTALSTAY: 'totalstay',
    TRAVCO: 'travco', // TODO: ask jerome if we can comment this out...
    // WORLD2MEET: 'world2meet',
    YALAGO: 'yalago',
};

CONSTANTS.DIRECT_BOOKABLE_SUPPLIERS = { // these are source we can book from directly
    BOOKING: 'booking',
    EXPEDIA: 'expedia',
    // make sure starts with lowercase
    PTC: 'ptc',
    // ARN: 'arn', Obsolete
    GOGLOBAL: 'goglobal',
    HOTELBEDS: 'hotelbeds',
    HYPERGUEST: 'hyperguest',
    PREMIERINN: 'premierinn',
    RESTEL: 'restel',
    SUNHOTELS: 'sunhotels',
    CTRIP: 'ctrip',
    TRAVELPORT: 'travelport',
    TBOHOLIDAYS: 'tboholidays',
    TRAVOLUTIONARY: 'travolutionary',
    YAYA: 'yaya',
    // If you add another here, don't forget to update reservations-etl getPriceAfterChooseProd and CONSTANTS.SUPPLIERS_FIELD_NAMES

    // Travelgate
    ...CONSTANTS.TRAVELGATE_BOOKABLE_SUPPLIERS,

    // If you add a new supplier, please make sure you also updated list of suppliers in packages/deals-grouper/gimmonix_deals_grouper.js
};

CONSTANTS.BOOKABLE_SUPPLIERS = {
    // If you add another here, don't forget to update reservations-etl getPriceAfterChooseProd and CONSTANTS.SUPPLIERS_FIELD_NAMES
    ...CONSTANTS.DIRECT_BOOKABLE_SUPPLIERS
};

CONSTANTS.SUPPLIERS_FIELD_NAMES = {
    [CONSTANTS.RESERVATION_SOURCES.ARN]: CONSTANTS.BOOKABLE_SUPPLIERS.ARN, // obsolete
    [CONSTANTS.RESERVATION_SOURCES.BOOKING]: CONSTANTS.BOOKABLE_SUPPLIERS.BOOKING,
    [CONSTANTS.RESERVATION_SOURCES.EXPEDIA]: CONSTANTS.BOOKABLE_SUPPLIERS.EXPEDIA,
    [CONSTANTS.RESERVATION_SOURCES.HOTELBEDS]: CONSTANTS.BOOKABLE_SUPPLIERS.HOTELBEDS,
    [CONSTANTS.RESERVATION_SOURCES.GOGLOBAL]: CONSTANTS.BOOKABLE_SUPPLIERS.GOGLOBAL,
    [CONSTANTS.RESERVATION_SOURCES.PREMIERINN]: CONSTANTS.BOOKABLE_SUPPLIERS.PREMIERINN,
    [CONSTANTS.RESERVATION_SOURCES.PTC]: CONSTANTS.BOOKABLE_SUPPLIERS.PTC,
    [CONSTANTS.RESERVATION_SOURCES.RESTEL]: CONSTANTS.BOOKABLE_SUPPLIERS.RESTEL,
    [CONSTANTS.RESERVATION_SOURCES.SUNHOTELS]: CONSTANTS.BOOKABLE_SUPPLIERS.SUNHOTELS,
    [CONSTANTS.RESERVATION_SOURCES.CTRIP]: CONSTANTS.BOOKABLE_SUPPLIERS.CTRIP,
    'sup-ean': 'ean', // obsolete
    [CONSTANTS.RESERVATION_SOURCES.TBOHOLIDAYS]: CONSTANTS.BOOKABLE_SUPPLIERS.TBOHOLIDAYS,
    [CONSTANTS.RESERVATION_SOURCES.TRAVELPORT]: CONSTANTS.BOOKABLE_SUPPLIERS.TRAVELPORT,
    [CONSTANTS.RESERVATION_SOURCES.TRAVOLUTIONARY]: CONSTANTS.BOOKABLE_SUPPLIERS.TRAVOLUTIONARY, // obsolete
    [CONSTANTS.RESERVATION_SOURCES.YAYA]: CONSTANTS.BOOKABLE_SUPPLIERS.YAYA,
    [CONSTANTS.RESERVATION_SOURCES.HYPERGUEST]: CONSTANTS.BOOKABLE_SUPPLIERS.HYPERGUEST,

    // Travelgate
    [CONSTANTS.RESERVATION_SOURCES.ABREU]: CONSTANTS.BOOKABLE_SUPPLIERS.ABREU,
    [CONSTANTS.RESERVATION_SOURCES.ASK2TRAVEL]: CONSTANTS.BOOKABLE_SUPPLIERS.ASK2TRAVEL,
    [CONSTANTS.RESERVATION_SOURCES.COSMOBEDS]: CONSTANTS.BOOKABLE_SUPPLIERS.COSMOBEDS,
    [CONSTANTS.RESERVATION_SOURCES.DARINA]: CONSTANTS.BOOKABLE_SUPPLIERS.DARINA,
    [CONSTANTS.RESERVATION_SOURCES.DIDA]: CONSTANTS.BOOKABLE_SUPPLIERS.DIDA,
    [CONSTANTS.RESERVATION_SOURCES.DOTW]: CONSTANTS.BOOKABLE_SUPPLIERS.DOTW,
    [CONSTANTS.RESERVATION_SOURCES.G2TRAVEL]: CONSTANTS.BOOKABLE_SUPPLIERS.G2TRAVEL,
    [CONSTANTS.RESERVATION_SOURCES.HOTELDO]: CONSTANTS.BOOKABLE_SUPPLIERS.HOTELDO,
    [CONSTANTS.RESERVATION_SOURCES.IOL]: CONSTANTS.BOOKABLE_SUPPLIERS.IOL,
    [CONSTANTS.RESERVATION_SOURCES.IMPERA]: CONSTANTS.BOOKABLE_SUPPLIERS.IMPERA,
    [CONSTANTS.RESERVATION_SOURCES.LETSFLY]: CONSTANTS.BOOKABLE_SUPPLIERS.LETSFLY,
    [CONSTANTS.RESERVATION_SOURCES.MIKI]: CONSTANTS.BOOKABLE_SUPPLIERS.MIKI,
    [CONSTANTS.RESERVATION_SOURCES.PRICETRAVEL]: CONSTANTS.BOOKABLE_SUPPLIERS.PRICETRAVEL,
    [CONSTANTS.RESERVATION_SOURCES.RAKUTEN]: CONSTANTS.BOOKABLE_SUPPLIERS.RAKUTEN,
    [CONSTANTS.RESERVATION_SOURCES.ROOMERANG]: CONSTANTS.BOOKABLE_SUPPLIERS.ROOMERANG,
    [CONSTANTS.RESERVATION_SOURCES.RTS]: CONSTANTS.BOOKABLE_SUPPLIERS.RTS,
    [CONSTANTS.RESERVATION_SOURCES.THREEFULLSTEPS]: CONSTANTS.BOOKABLE_SUPPLIERS.THREEFULLSTEPS,
    [CONSTANTS.RESERVATION_SOURCES.SMYROOMS]: CONSTANTS.BOOKABLE_SUPPLIERS.SMYROOMS,
    [CONSTANTS.RESERVATION_SOURCES.TRAVCO]: CONSTANTS.BOOKABLE_SUPPLIERS.TRAVCO,
    [CONSTANTS.RESERVATION_SOURCES.TRAVCODUBAI]: CONSTANTS.BOOKABLE_SUPPLIERS.TRAVCODUBAI,
    [CONSTANTS.RESERVATION_SOURCES.VOYAGETOURS]: CONSTANTS.BOOKABLE_SUPPLIERS.VOYAGETOURS,
    [CONSTANTS.RESERVATION_SOURCES.WORLD2MEET]: CONSTANTS.BOOKABLE_SUPPLIERS.WORLD2MEET,
    [CONSTANTS.RESERVATION_SOURCES.HOTELTRADER]: CONSTANTS.BOOKABLE_SUPPLIERS.HOTELTRADER,
    [CONSTANTS.RESERVATION_SOURCES.HOTELSENSE]: CONSTANTS.BOOKABLE_SUPPLIERS.HOTELSENSE,
    [CONSTANTS.RESERVATION_SOURCES.YALAGO]: CONSTANTS.BOOKABLE_SUPPLIERS.YALAGO,
};

// Canonical masked identifiers for reservation sources, used to hide the
// real supplier in reports sent externally (e.g. the El Al sales feed).
// These ids MUST be stable across releases.
// Do NOT reorder or change any existing mapping below — downstream consumers and
// historical reports rely on the existing supplier -> Xn assignment.
// When adding a NEW supplier, APPEND the next sequential Xn at the END only.
CONSTANTS.MASKED_RESERVATION_SOURCES = {
    [CONSTANTS.RESERVATION_SOURCES.EXPEDIA]: 'X1',
    [CONSTANTS.RESERVATION_SOURCES.HOTELBEDS]: 'X2',
    [CONSTANTS.RESERVATION_SOURCES.DOTW]: 'X3',
    [CONSTANTS.RESERVATION_SOURCES.YALAGO]: 'X4',
    [CONSTANTS.RESERVATION_SOURCES.RESTEL]: 'X5',
    [CONSTANTS.RESERVATION_SOURCES.RAKUTEN]: 'X6',
    [CONSTANTS.RESERVATION_SOURCES.TBOHOLIDAYS]: 'X7',
    [CONSTANTS.RESERVATION_SOURCES.SUNHOTELS]: 'X8',
    [CONSTANTS.RESERVATION_SOURCES.GOGLOBAL]: 'X9',
    [CONSTANTS.RESERVATION_SOURCES.TRAVCO]: 'X10',
    [CONSTANTS.RESERVATION_SOURCES.CTRIP]: 'X11',
    [CONSTANTS.RESERVATION_SOURCES.MIKI]: 'X12',
    [CONSTANTS.RESERVATION_SOURCES.HOTELDO]: 'X13',
    [CONSTANTS.RESERVATION_SOURCES.PRICETRAVEL]: 'X14',
    [CONSTANTS.RESERVATION_SOURCES.G2TRAVEL]: 'X15',
    [CONSTANTS.RESERVATION_SOURCES.DIDA]: 'X16',
    [CONSTANTS.RESERVATION_SOURCES.IOL]: 'X17',
    [CONSTANTS.RESERVATION_SOURCES.SMYROOMS]: 'X18',
    [CONSTANTS.RESERVATION_SOURCES.COSMOBEDS]: 'X19',
    [CONSTANTS.RESERVATION_SOURCES.WORLD2MEET]: 'X20',
    [CONSTANTS.RESERVATION_SOURCES.ABREU]: 'X21',
    [CONSTANTS.RESERVATION_SOURCES.THREEFULLSTEPS]: 'X22',
    [CONSTANTS.RESERVATION_SOURCES.LETSFLY]: 'X23',
    [CONSTANTS.RESERVATION_SOURCES.HYPERGUEST]: 'X24',
    [CONSTANTS.RESERVATION_SOURCES.ROOMERANG]: 'X25',
    [CONSTANTS.RESERVATION_SOURCES.DARINA]: 'X26',
    [CONSTANTS.RESERVATION_SOURCES.ASK2TRAVEL]: 'X27',
    [CONSTANTS.RESERVATION_SOURCES.VOYAGETOURS]: 'X28',
    [CONSTANTS.RESERVATION_SOURCES.TRAVCODUBAI]: 'X29',

    [CONSTANTS.RESERVATION_SOURCES.PREMIERINN]: undefined,
    [CONSTANTS.RESERVATION_SOURCES.TRAVELPORT]: undefined,
    [CONSTANTS.RESERVATION_SOURCES.HOTELTRADER]: undefined,
    [CONSTANTS.RESERVATION_SOURCES.HOTELSENSE]: undefined,
    [CONSTANTS.RESERVATION_SOURCES.IMPERA]: undefined,
};

// Translate a reservation's source (RESERVATION_SOURCES value) to its masked id.
// Returns undefined when the source has no mapping (caller decides how to handle it).
CONSTANTS.getMaskedReservationSource = function (source) {
    return CONSTANTS.MASKED_RESERVATION_SOURCES[source];
};